<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on" @click="openModel">CREATE ORDER</span>
    </template>

    <v-card>
      <v-card-title>Create number transfer order</v-card-title>

      <v-card-text>
        <template v-if="numbersInRangeLoading || productsLoading">
          <v-skeleton-loader max-width="300" type="list-item-two-line"></v-skeleton-loader>
        </template>
        <template v-else>
          <template v-if="numbersInRangeError"><p class="error--text mt-5 mb-0">Error loading numbers in range</p></template>
          <template v-else>
            <template>
              <div v-if="telcoOrderInProgress" class="mb-5">
                <v-alert color="watermelon" dense>
                  <v-checkbox dense v-model="telcoOrderExists" dark class="text-subtitle-2" label="This customer has an in-progress telco order, are you sure you want to start this number transfer?"
                  ></v-checkbox>
                </v-alert>
              </div>

              <div class="mb-5" v-else>
                Are you sure you want to create the number transfer order?
              </div>
            </template>

            <span><b>Numbers to transfer</b></span>
            <div class="d-flex flex-column" v-for="(item, i) in numbers" :key="i">
              {{ item }}
            </div>
          </template>

          <template v-if="isPortError"><p class="error--text mt-5 mb-0">{{portKindError}}</p></template>
        </template>


      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="telcoOrderInProgress" color="primary" small :disabled="createTransferOrderLoading || !telcoOrderExists || isPortError" :loading="createTransferOrderLoading" @click.prevent="submit({numberRange: numbersInRange.id, productId: numbersInRange.voip_site_id})">Transfer</v-btn>

        <v-btn v-else color="primary" small :disabled="createTransferOrderLoading || numbersInRangeLoading || isPortError" :loading="createTransferOrderLoading" @click.prevent="submit({numberRange: numbersInRange.id, productId: numbersInRange.voip_site_id})">Transfer</v-btn>
        <v-btn color="primary" small outlined class="ml-3" :disabled="createTransferOrderLoading" @click="dialog = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      boilerplate: true,
      telcoOrderExists: false,
      portKindError: '',
      isPortError: false,
    }
  },
  watch: {
    dialog(val) {
      if(val){
        this.isPortError = false;
        if(['IPEX','RESELLER'].indexOf(this.item.port_kind)!==-1){
          this.portKindError = 'Cannot create automated order for IPEX or Reseller-to-Reseller transfers';
          this.isPortError = true;
        }else if(['MANUAL_GEOGRAPHIC'].indexOf(this.item.port_kind)!==-1){
          this.portKindError = 'Please change the order type to Geographic to create an automated order';
          this.isPortError = true;
        }
      }
    }
  },
  computed: {
    ...mapState("numbers", ["numbersInRange", "numbersInRangeLoading", "numbersInRangeError", "createTransferOrderLoading"]),
    ...mapState("products", ["currentProduct", "productsLoading"]),
    ...mapGetters("products", ["telcoOrderInProgress"]),

    // eslint-disable-next-line
    telcoOrder() {
      // eslint-disable-next-line
      this.telcoOrderExists = this.telcoOrderInProgress;
    },
    // eslint-disable-next-line
    numbers() {
      const nums_range = [];
      if(this.numbersInRange) {
        const range_length = this.numbersInRange.porting_range_length;
        let num_start = this.numbersInRange.porting_range_start;
        if(range_length > 1) {
          for(let i = 0; i < range_length; i++) {
            nums_range.push(`0${parseInt(num_start) + i}`);
          }
          return nums_range;
        }
        return [this.numbersInRange.porting_range_start];
      }
    },
  },
  methods: {
    ...mapActions("numbers", ["getNumbersInRange", "createTransferOrder"]),
    ...mapActions("products", ["getAccountProducts"]),
    ...mapActions("alerts", ["setAlert"]),

    loadNumberRange(item) {
      return this.getNumbersInRange(item);
    },
    
    openModel() {
      this.loadNumberRange(this.item.id);
      this.getAccountProducts(this.currentProduct.account_id);
    },

    async submit(data) {
      try {
        await this.createTransferOrder(data);
        this.$emit('refresh-numbers');
        this.dialog = false;
      } catch(err) {
        return err;
      }
    },
  },
}
</script>

<style>
</style>
